// https://vuex.vuejs.org/en/getters.html

// authorized lets you know if the token is true or not
export default {
  authorized: state => !!state.token && (new Date(state.vencimiento))>(new Date()),
  authstatus: state => state.authStatus,
  user: state => state.user,
  username: state => state.username,
  rolesuser: state => state.rolesuser,
  rolesuserid: state => state.rolesuserid,
  rolesid: state => state.rolesid,
  permisos: state => state.permisos,
  vencimiento: state => state.vencimiento,
  foto: state => state.foto,
  idestado: state => state.idestado,
  idsede: state => state.idsede,
  mensaje: state => state.mensaje,
  idpersona: state => state.idpersona
}
